import { useMemo, type ReactNode } from 'react';
import { useAuth } from '@/lib/auth/client-auth';
import { RoamConvexClient } from '@/lib/data/RoamConvexClient';
import { ConvexProviderWithClerk } from 'convex/react-clerk';

const clients = new Map<string, RoamConvexClient>();

function getConvexClient(convexUrl: string) {
  const existing = clients.get(convexUrl);
  if (existing) return existing;
  const client = new RoamConvexClient(convexUrl);
  clients.set(convexUrl, client);
  return client;
}

export function RoamAppProviders({
  children,
  convexUrl,
}: {
  children: ReactNode;
  convexUrl: string;
}) {
  const convex = useMemo(() => getConvexClient(convexUrl), [convexUrl]);
  return (
    <ConvexProviderWithClerk client={convex} useAuth={useAuth}>
      {children}
    </ConvexProviderWithClerk>
  );
}
